import React, { useEffect, useRef, useState } from "react";
import { OverlayTrigger, ProgressBar, Tooltip } from "react-bootstrap";
import Assets from "../../Layouts/Assets";
import Icons from "../../Layouts/Icons";
import CommonModal from "../CommonModal";
import Style from "./FPAImageUploadModal.module.scss";
import "swiper/css/free-mode";
import { FreeMode } from "swiper";
import { useFPAUploadModal } from "../../../Logic/FPA Uploader/useFPAUploadModal";
import { useDispatch, useSelector } from "react-redux";
import { FixedSizeList } from "react-window";
import Thumb from "../ImageUploadModal/Thumb";

const FPAImageUploadModal = ({
  showModal,
  setShowModal,
  handleDragOver,
  handleDragOut,
  handleDrop,
  handleImageChange,
  uploadReadyImages,
  uploadResponses,
  currentlyUploading,
  fileInputRef,
  fileUploadState,
}) => {
  const ListItem = ({ data, index, style }) => {
    return (
      <div
        className={`${Style.file_upload_preview_wrap} file_upload_preview_wrap`}
        style={style}
      >
        <Thumb image={data[index]} />
      </div>
    );
  };
  const thumData =
    currentlyUploading &&
    uploadResponses?.total - uploadReadyImages?.length >
      uploadResponses?.uploaded &&
    uploadResponses?.total !== 0
      ? uploadReadyImages?.length > 0 && uploadResponses?.uploaded < 2
        ? [
            currentlyUploading,
            ...uploadResponses?.uploadedImage?.reverse()?.slice(-2),
            { duplicate: true, count: uploadReadyImages?.length },
          ]
        : [
            currentlyUploading,
            ...uploadResponses?.uploadedImage?.reverse()?.slice(-5),
          ]
      : uploadReadyImages?.length > 0
      ? [
          ...uploadResponses?.uploadedImage?.reverse()?.slice(-5),
          { duplicate: true, count: uploadReadyImages?.length },
        ]
      : [...uploadResponses?.uploadedImage?.reverse()?.slice(-5)];

  return (
    <>
      <CommonModal
        backdrop="static"
        keyboard={false}
        showModal={showModal}
        setShowModal={setShowModal}
        centered={true}
        className={Style.ImageUploadModal}
        content={
          <>
            {fileUploadState?.isUploading &&
            uploadResponses?.uploadedImage[0]?.result?.code !== 402 ? ( //uploading progress warning...
              <div className={Style.warningBox}>
                <img src={Assets?.upload_progress} alt="" />
                <h4>upload in Progress!</h4>
                <span>
                  uploading is progress, Please wait until the process is
                  complete.
                </span>
              </div>
            ) : (
              <div
                className={Style.ImageUploadModal__uploadBox}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
                onDragLeave={handleDragOut}
              >
                <label htmlFor="uploadImg">
                  <figure>
                    <img src={Assets.blank_data_placeholder} alt="" />
                  </figure>
                  <span>
                    Drag and drop an image, <span>or Browse</span>
                  </span>
                  <p>Photos will be uploaded to the client's FPA account.</p>

                  <input
                    ref={fileInputRef}
                    onChange={handleImageChange}
                    type="file"
                    className="d-none"
                    name=""
                    accept="image/gif, image/jpeg, image/png"
                    id="uploadImg"
                    multiple
                  />
                </label>
              </div>
            )}
            {!fileUploadState?.isUploading && (
              <div className={Style.ImageUploadModal__preview}>
                <div className={`${Style.file_upload_status} me-3 ms-0`}>
                  <div
                    className={`${Style.add_more_btn_contents} 
                  ${
                    uploadResponses?.total - uploadReadyImages?.length !==
                      uploadResponses?.uploaded &&
                    uploadReadyImages?.length != 0 &&
                    "inprogress"
                  }
                   `}
                  >
                    <strong className="mb-sm-1">File Upload</strong>

                    <span>
                      {uploadResponses?.uploaded >
                      uploadResponses?.total - uploadReadyImages?.length
                        ? uploadResponses?.total - uploadReadyImages?.length
                        : uploadResponses?.uploaded}
                      /{uploadResponses?.total - uploadReadyImages?.length}
                    </span>

                    <OverlayTrigger
                      key={"bottom"}
                      placement={"bottom"}
                      variant="danger"
                      overlay={
                        <Tooltip
                          id={`tooltip-bottom`}
                          className={Style.tooltip_bottom}
                        >
                          <span>
                            Total - <strong>{uploadResponses?.total}</strong>
                          </span>
                          <span>
                            Uploaded -{" "}
                            <strong>{uploadResponses?.uploaded}</strong>
                          </span>
                          <span>
                            Duplicate -{" "}
                            <strong>
                              {
                                uploadReadyImages?.filter(
                                  (item) => item.duplicate
                                )?.length
                              }
                            </strong>
                          </span>
                          <span>
                            Invalid -{" "}
                            <strong>
                              {
                                uploadReadyImages?.filter(
                                  (item) => item.invalid
                                )?.length
                              }
                            </strong>
                          </span>
                        </Tooltip>
                      }
                    >
                      <button
                        className={`btn btn-link border px-2 ${Style.upload_image_info_btn}`}
                      >
                        !
                      </button>
                    </OverlayTrigger>
                  </div>
                </div>

                <div className={Style.file_upload_list_wrap_inneritem}>
                  <FixedSizeList
                    itemData={thumData}
                    height={70}
                    itemCount={thumData?.length}
                    itemSize={124}
                    width={400}
                    direction="horizontal"
                    style={{ flex: "1 0", width: "100%" }}
                    className={Style.file_upload_list_wrap}
                  >
                    {ListItem}
                  </FixedSizeList>
                </div>

                <label className={Style.add_more_btn} for="uploadImg">
                  <Icons size={18} icon={"icon-plus"} />
                  <br />
                  <span>Add more</span>
                </label>
              </div>
            )}

            {uploadResponses?.uploadedImage[0]?.result?.code === 402 && (
              <span className={Style.errorMsg}>
                {uploadResponses?.uploadedImage[0]?.result?.message}
              </span>
            )}

            {/*************************************************************
             * when complete image upload its automatically reflect in FPA *
             **************************************************************/}
            {/* 
            {fileUploadState?.totalUploadImages?.length -
              duplicateImages?.length >
              0 &&
              uploadedCount ==
                fileUploadState?.totalUploadImages?.length -
                  duplicateImages?.length && (
                <div className={Style.ImageUploadModal_files_noti}>
                  <p>Files are uploaded to FPA successfully.</p>
                </div>
              )} */}

            {/* <div className={Style.ImageUploadModal__button}>
              <button
                className="btn btn-primary"
                disabled={
                  fileUploadState?.totalUploadImages?.length > 0 &&
                  uploadedCount == fileUploadState?.totalUploadImages?.length - duplicateImages?.length
                    ? false
                    : true
                }
                onClick={() => closeUploadModal()}
              >
                Done
              </button>
            </div> */}

            {uploadResponses?.total - uploadReadyImages?.length ==
              uploadResponses?.uploaded &&
              uploadResponses?.uploaded !== 0 && (
                <span className={Style.sucessMsg}>
                  Image uploaded Successfully.
                </span>
              )}
          </>
        }
      />
    </>
  );
};

export default FPAImageUploadModal;

const imageData = [
  {
    id: 1,
    image: Assets.photo1,
  },
  {
    id: 2,
    image: Assets.photo2,
  },
  {
    id: 3,
    image: Assets.photo3,
  },
  {
    id: 4,
    image: Assets.photo4,
  },
  {
    id: 5,
    image: Assets.photo5,
  },
  {
    id: 6,
    image: Assets.photo6,
  },
  {
    id: 7,
    image: Assets.photo7,
  },
];
